import { SelectMonth } from 'app/components/commonFilters/components'
import { COMPETITION_URL } from 'app/@common/constants'
import React, {useMemo} from 'react'
import { useAppMonthSelector } from './@hooks'
import { useContextSelector } from 'use-context-selector'
import { CompetitionAnalyzerReportExecutionContext } from 'app/pages/Competition/Analyzer2.1/Providers'
import { ParityReportExecutionContext } from 'app/pages/Parity/Analyzer2.1/Providers'
import { PackagesReportExecutionContext } from 'app/pages/Packages/Analyzer2.1/Providers'
import { getSection } from 'app/utils'


export default function AppHeaderMonth({ url = COMPETITION_URL.DATE_RANGE }) {
    /*const optionsRef = useRef([])*/
    const { monthYear, setMonthYear } = useAppMonthSelector()
    
    const section = useMemo(() => getSection(window.location.href), [])
    const ReportExecutionContext = section === 'competition' 
        ? CompetitionAnalyzerReportExecutionContext 
        : section === 'packages' 
            ? PackagesReportExecutionContext 
            : ParityReportExecutionContext
    const idReportExecution = useContextSelector(ReportExecutionContext, ({ state }) => state?.idReportExecution)

    /*useEffect(() => {
        if (optionsRef.current.length) {
            const exists = optionsRef.current.some(opt => opt.value === monthYear)
            if (!exists && monthYear !== 'custom') {
                const firstOption = optionsRef.current[0]
                if (firstOption) {
                    const { value, lastDate } = firstOption
                    setMonthYear({
                        monthYear: value,
                        lastDate,
                        numMonths: optionsRef.current.length
                    });
                }
            }
        }
    }, [monthYear, setMonthYear]);*/

    return <div className="select-dates-header" style={{ border: 0 }}>
        <SelectMonth
            value={monthYear}
            onChange={({value}) => setMonthYear({ monthYear: value })}
            method="POST"
            urlAjax={url}
            extraParams={{
                ...idReportExecution && { id_report_execution: idReportExecution }
            }}
            onAjax={(options = []) => {
                /*optionsRef.current = options;*/
                if (!monthYear || monthYear === 'custom') {
                    const { value } = options[0]
                    setMonthYear({ monthYear: value, lastDate: options[0].lastDate, numMonths: options.length })
                } else {
                    if (!options.some(opt => opt.value === monthYear) && options[0]) {
                        const { value, lastDate } = options[0]
                        setMonthYear({ monthYear: value, lastDate, numMonths: options.length})
                    }
                }
                return options
            }}
        />
    </div>
}